import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon QuotesIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const QuotesIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 70 70">
      <g id="Group_4139">
        <g id="Group_4156">
          <g id="Group_4154">
            <g id="Path_2002">
              <path d="M32.86,54.52c-0.74,0-1.44-0.27-1.99-0.77l-0.16-0.16c-0.69-0.75-4.19-4.2-7.28-7.24 c-3.22-3.17-5.2-5.13-5.55-5.52c-0.08-0.09-0.17-0.18-0.25-0.27c-0.68-0.72-2.11-2.22-0.32-4.24l0.52-0.59l0.04,0.02 c3.08-3.19,16.39-16.37,17-16.97c0.64-0.74,1.64-1.21,2.7-1.25c0.55,0.01,2.63,0,4.83-0.01c4.25-0.02,7.08-0.03,7.52,0.01 c0.07,0.01,0.15,0.01,0.23,0.01c0.77,0.03,3.09,0.14,3.3,3.02c0.16,2.24,0.01,12.41,0,12.84c0.04,0.95-0.27,1.96-0.88,2.78 C51.77,37.1,36.72,51.91,35,53.59c-0.49,0.54-1.21,0.88-2,0.92C32.95,54.52,32.91,54.52,32.86,54.52z M18.6,37.99 c-0.22,0.34-0.06,0.53,0.52,1.15c0.1,0.11,0.21,0.22,0.3,0.32c0.32,0.36,2.93,2.93,5.46,5.42c3.26,3.21,6.63,6.53,7.32,7.29 l0.09,0.09c0.14,0.13,0.38,0.21,0.61,0.2c0.24-0.01,0.45-0.11,0.61-0.29c6.75-6.64,16.92-16.67,17.44-17.28 c0.28-0.38,0.45-0.93,0.43-1.47c0-0.16,0.15-10.57,0-12.72c-0.07-1-0.46-1.06-1.34-1.1c-0.13-0.01-0.25-0.01-0.35-0.02 c-0.43-0.04-4.4-0.02-7.3,0c-2.31,0.01-4.31,0.02-4.82,0.01c-0.43,0.02-0.9,0.24-1.22,0.61c-0.21,0.21-16.22,16.06-17.5,17.51 L18.6,37.99z" />
            </g>
            <g id="Ellipse_29">
              <g>
                <circle fill="none" cx={45.81} cy={26.25} r={3.38} />
              </g>
              <g>
                <path d="M45.81,29.63c-1.86,0-3.38-1.51-3.38-3.38s1.51-3.38,3.38-3.38c1.86,0,3.38,1.51,3.38,3.38 S47.67,29.63,45.81,29.63z M45.81,24.93c-0.73,0-1.32,0.59-1.32,1.32s0.59,1.32,1.32,1.32s1.32-0.59,1.32-1.32 S46.54,24.93,45.81,24.93z" />
              </g>
            </g>
          </g>
          <g id="Group_4155">
            <g id="Path_1985">
              <path d="M35.05,43.02c-0.49,0-0.98-0.06-1.48-0.17c-1.65-0.38-3.03-1.38-3.69-2.67 c-0.26-0.51-0.06-1.13,0.44-1.39c0.51-0.26,1.13-0.06,1.39,0.45c0.39,0.76,1.26,1.36,2.32,1.61c1.19,0.28,2.38,0.06,3.26-0.59 c0.73-0.54,1.04-1.37,0.78-2.1c-0.34-0.97-1.6-1.53-3.3-1.47c-3.1,0.12-4.45-1.64-4.65-3.15c-0.25-1.99,1.21-3.86,3.41-4.36 c2.21-0.68,4.72,0.14,6.17,2.05c0.34,0.45,0.25,1.1-0.2,1.44s-1.1,0.25-1.44-0.2c-0.93-1.23-2.54-1.75-4.01-1.31 c-1.39,0.32-1.99,1.32-1.89,2.11c0.11,0.88,1.1,1.41,2.54,1.36c2.66-0.09,4.66,0.98,5.31,2.84c0.55,1.57-0.05,3.35-1.49,4.43 C37.54,42.63,36.33,43.02,35.05,43.02z" />
            </g>
            <g id="Path_1986">
              <path d="M35,31.05c-0.57,0-1.03-0.46-1.03-1.03v-3.35c0-0.57,0.46-1.03,1.03-1.03s1.03,0.46,1.03,1.03v3.35 C36.03,30.59,35.57,31.05,35,31.05z" />
            </g>
            <g id="Path_1987">
              <path d="M35,46.35c-0.57,0-1.03-0.46-1.03-1.03v-3.35c0-0.57,0.46-1.03,1.03-1.03s1.03,0.46,1.03,1.03v3.35 C36.03,45.89,35.57,46.35,35,46.35z" />
            </g>
          </g>
        </g>
      </g>
    </Icon>
  )
}
export default QuotesIcon
